import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const duplicatesSearchSchema = z.object({
	recordType: z.enum(['Contact', 'Company']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/duplicates/')({
	validateSearch: duplicatesSearchSchema,
	beforeLoad: ({ search }) => {
		throw redirect({
			to: search.recordType === 'Company' ? '/crm/companies' : '/crm/contacts',
			search: { duplicates: '1' },
		});
	},
});
